// extracted by mini-css-extract-plugin
export default {"control":"NavbarLinksGroup_control__mVyQX","link":"NavbarLinksGroup_link__Y35ui","chevron":"NavbarLinksGroup_chevron__ygu6o"};